import { insuranceCompany } from '@/types/types';
import { ActionContext } from 'vuex';

export const ADD_PROPOSAL_STEPS = 'ADD_PROPOSAL_STEPS';
export const ADD_PROPOSAL_INFO = 'ADD_PROPOSAL_INFO';
export const PROPOSAL_INFO_ERROR = 'PROPOSAL_INFO_ERROR';
export const PROPOSAL_LOADED = 'PROPOSAL_LOADED';
// export const UPDATE_PROPOSAL = 'UPDATE_PROPOSAL';

export interface ProposalContextState {
	proposalSteps: Map<string, any>;
	party?: {
		address?: string;
		customer_no: string;
		name: string;
		customer_type: 'PRIMARY' | 'SECONDARY';
	};
	quote_id: string;
	customerNo: string;
	price: number;
	signatureId: string;
	modal;
	originalRequest;
	insuranceCompanies: Array<insuranceCompany>;
}

const state: ProposalContextState = {
	proposalSteps: new Map(),
	party: undefined,
	quote_id: undefined,
	customerNo: undefined,
	price: undefined,
	signatureId: undefined,
	modal: undefined,
	originalRequest: undefined,
	insuranceCompanies: undefined,
};

const mutations = {
	[ADD_PROPOSAL_STEPS](state: any, proposalSteps: Array<any>) {
		proposalSteps.forEach((step) => {
			state.proposalSteps.set(step.id, step);
		});
	},
	[ADD_PROPOSAL_INFO](state: any, proposalInfo: any) {
		state.party = proposalInfo.party;
		state.payment = proposalInfo.payment;
		state.price = proposalInfo.price;
	},
	[PROPOSAL_INFO_ERROR](state: any) {
		//subscription event
	},
	[PROPOSAL_LOADED](state: any) {
		//subscription event
	},
};

const actions = {
	async [ADD_PROPOSAL_STEPS]({ commit, state, dispatch }: ActionContext<any, any>, proposalSteps: Array<any>) {
		commit(ADD_PROPOSAL_STEPS, proposalSteps);
		//dispatch(PROPOSAL_STEPS_LOADED); // notify subscribers
	},
	async [ADD_PROPOSAL_INFO]({ commit, state, dispatch }: ActionContext<any, any>, proposalInfo: any) {
		commit(ADD_PROPOSAL_INFO, proposalInfo);
		//dispatch(PROPOSAL_STEPS_LOADED); // notify subscribers
	},
	async [PROPOSAL_INFO_ERROR]({ commit, state, dispatch }: ActionContext<any, any>) {
		commit(PROPOSAL_INFO_ERROR);
		//dispatch(PROPOSAL_STEPS_LOADED); // notify subscribers
	},
	async [PROPOSAL_LOADED]({ commit, state, dispatch }: ActionContext<any, any>) {
		commit(PROPOSAL_LOADED);
	},
};

export default {
	state,
	mutations,
	actions,
};
